<template>
  <div class="designer-v3-page-main">
    <DesignerV3 :viewMode="false" :showBackground.sync="showBackground" :canClose="false"/>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      showBackground: true,
    }
  },
  props: {
  },
  methods: {
  },
  mounted() {
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';


</style>